<div class="allshipimages">

    <!-- ITERATE THROUGH EACH IMAGE RETURNED FROM ENDPOINT -->
    <div *ngFor="let imgData of bannerimages; let idx=index;" class="row justify-content-center">
        <div class="col-11 accordian-item-border">

            <!-- DIV BELOW IS USED FOR DISPLAYING THE SIDE VIEW OF THIS SHIP -->
            <div *ngIf='imgData.dplDeck == "Side"' class="accordian-item">
                <img class="img-fluid"
                    src="{{imgPath}}deckimages/{{imgData.dplImage}}" 
                    onerror="this.style.display='none'" 
                    [ngClass]="{'deckhighlight':imgData.highlight!=true}"
                    alt="...">
            </div>
            
            <!-- DIV BELOW USED TO EXPAND AND MINIMIZE THE ACCORDIAN ITEM (DISPLAYING THE DECK MAP) -->
            <div *ngIf='imgData.dplDeck != "Side"' (click)="toggleAccordianItem(idx)" class="col-11 accordian-item">
                <!-- DIV BELOW USED TO ESTABLISH ACCORDIAN ITEM TEXT -->
                <div class="deck-number">
                    <span *ngIf='imgData.dplDeck != "1st"'>{{imgData.dplDeck}} Deck</span>
                    <span *ngIf='imgData.dplDeck == "1st"'>Main Deck</span>
                    <i class="fa-solid fa-circle-minus fa-lg float-end mt-2"  *ngIf='imgData.expanded == true'></i>
                    <i class="fa-solid fa-circle-plus fa-lg float-end mt-2"  *ngIf='imgData.expanded == false'></i>
                </div>      
            </div>
            
            <!-- DIV BELOW IS USED TO RENDER DECK IMAGE IF THE ACCORDIAN ITEM IS TOGGLED -->
            <div class="col-11 "  *ngIf='imgData.expanded'>
                <app-image-zoom-container [imgPath]="imgPath + 'deckimages/' + imgData.dplImage"></app-image-zoom-container>
            </div>
            
            <!-- DIV BELOW IS USED TO CENTER TEXT INDICATING SWIPING FEATURE -->
            <div class="row p-2 text-center mb-3" *ngIf='imgData.expanded'>
                <i>
                    <img src="https://www.americancruiselines.com/libraries/acl/images/style-assets/icons/swipe.svg" alt="swipe">
                    <i class="drop-down-text ms-1">Swipe to explore deck detail</i>
                </i>
            </div>
        </div>            
    </div>
</div>
    